import { createContext, useContext, type ReactNode } from 'react';

/**
 * Own context (not the shared `BuilderModeV1IndicatorIconContext`) so
 * swapping in these new Calc1/Input5 icons only affects this module's own
 * table, without touching the legacy or BuilderModeV1 icon sets that other
 * modules render through the same shared `IndicatorIcon` in
 * `utils/ReactGridUtils.tsx`.
 */
const ModernIndicatorIconContext = createContext(false);

export const ModernIndicatorIconProvider = ({
  value,
  children,
}: {
  value: boolean;
  children: ReactNode;
}) => (
  <ModernIndicatorIconContext.Provider value={value}>
    {children}
  </ModernIndicatorIconContext.Provider>
);

export const useModernIndicatorIcons = () => useContext(ModernIndicatorIconContext);
